<template>
    <section class="content px-3">
        <div class="card">
            <div class="card-header">
                <div class="card-title pt-1 mb-0">
                    <i class="fas fa-list-ol"></i> Manage Supplier
                </div>
                <div class="card-tools mr-0">
                    <button type="button" class="btn btn-primary" @click="addNew">
                        <i class="fas fa-plus-square"></i> Buat Supplier
                    </button>
                </div>
            </div>
            <div class="card-body">
                <div class="mb-3">
                    <search-bar @search-set="searchSet" @search-reset="searchReset"></search-bar>
                </div>
                <div class="table-responsive">
                    <vuetable ref="vuetable"
                        api-url="/api/suppliers"
                        :fields="customFields"
                        :per-page="perPage"
                        :sort-order="sortOrder"
                        pagination-path="meta"
                        data-path="data"
                        :append-params="moreParams"
                        @vuetable:pagination-data="onPaginationData"
                        :css="css.table"
                        @vuetable:loading="$Progress.start()"
                        @vuetable:loaded="$Progress.finish()"
                        @vuetable:load-error="requestFailed"
                    >
                        <template slot="action-slot" slot-scope="props">
                            <button type="button" title="Edit" @click="edit(props.rowData)" class="btn btn-link px-1"><i class="fas fa-edit"></i></button>
                            <button type="button" title="Delete" @click="deleteData(props.rowData)" class="btn btn-link px-1 text-danger"><i class="fas fa-trash-alt"></i></button>
                        </template>
                    </vuetable>
                </div>
                <div>
                    <vuetable-pagination-info ref="paginationInfo"
                        :css="css.paginationInfo"
                    ></vuetable-pagination-info>
                </div>
                <div>
                    <vuetable-pagination ref="pagination"
                        @vuetable-pagination:change-page="onChangePage"
                        :css="css.pagination"
                    ></vuetable-pagination>
                </div>
                <div>
                    <pagination-per-page :perPage="perPage" @update="onChangePerPage"></pagination-per-page>
                </div>
            </div>
        </div>

        <b-modal v-model="editModal" size="md" :hide-header="true" :hide-footer="true">
            <edit-form :isEdit="isEdit" :value="currentUser" @saved="saved" @cancel="editModal = false"></edit-form>
		</b-modal>
    </section>
</template>

<script>
import VuetableMixin from '../../mixin/vuetable2';
import EditForm from './Form';
import SearchBar from './SearchBar';

export default {
    name: "suppliers",

    components: {
        EditForm,
        SearchBar,
    },

    mixins: [VuetableMixin],

    data() {
        return {
            perPage: 10,
            editModal: false,
            isEdit: false,
            currentUser: null,
            searchText: '',
        }
    },

    created() {
    },

    mounted() {
    },

    computed: {
        customFields() {
            return [
                {
                    name: '__sequence',
                    title: "#",
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
                {
                    name: 'code',
                    title: 'Kode',
                    sortField: 'code',
                },
                {
                    name: 'name',
                    title: 'Nama',
                    sortField: 'name',
                },
                {
                    name: 'gudang.gudang.name',
                    title: 'Gudang',
                    sortField: 'gudang_name',
                },
                {
                    name: 'created_at',
                    title: 'Dibuat Pada',
                    sortField: 'created_at',
                    callback: 'formatDatetime',
                },
                {
                    name: 'updated_at',
                    title: 'Diperbarui Pada',
                    sortField: 'updated_at',
                    callback: 'formatDatetime',
                },
                {
                    name: '__slot:action-slot',
                    title: 'Aksi',
                    titleClass: "text-center",
                    dataClass: "text-center",
                },
            ]
        },

        sortOrder() {
            return [
                { field: "updated_at", direction: "desc" }
            ];
        },

        moreParams() {
            return {
                search: this.searchText,
            };
        },
    },

    methods: {
        searchSet(searchText) {
            this.searchText = searchText;
            this.refresh();
        },

        searchReset() {
            this.searchText = '';
            this.refresh();
        },

        addNew() {
            this.isEdit = false;
            this.currentUser = null;
            this.editModal = true;
        },

        edit(rowData) {
            this.isEdit = true;
            this.currentUser = Object.assign({}, rowData);
            this.editModal = true;
        },

        saved() {
            this.editModal = false;
            this.currentUser = null;
            this.refresh();
        },

        deleteData(rowData) {
            let self = this;

            Swal.fire({
                title: 'Apakah anda yakin?',
                text: "Anda tidak dapat mengembalikan data yang sudah dihapus!",
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Ya, hapus!'
            }).then((result) => {
                // Send request to the server
                if (result.value) {
                    self.$Progress.start();
                    axios({
                        method: 'delete',
                        url: '/api/suppliers/' + rowData.id,
                    })
                    .then(function (response) {
                        Toast.fire({
                            icon: 'success',
                            title: response.data.message
                        });
                        self.$Progress.finish();
                        self.refresh();
                    })
                    .catch(function (error) {
                        self.responseFailed(error);
                    });
                }
            })
        },
    },
}
</script>
